// CUSTOM: 送料無料までの残額を動的に表示する
// 1. お知らせバー(.announcement-bar__text)のテキスト書き換え
// 2. カートページ(.cart-totals__tax-note の直後)に送料情報を挿入
// しきい値・文言を変更したい場合は下の CONFIG を編集してください

(function () {
  'use strict';

  // ====== 設定(ここを編集すれば文言・しきい値を変更できます) ======
  const CONFIG = {
    threshold: 12000, // 送料無料のしきい値(円)
    messageBelow: '🚚 送料無料まであと{remaining}円',
    messageAchieved: '🚚 送料無料でお届けします',
    // カートが空のとき:
    //   - お知らせバー: 元の管理画面設定テキストに戻す
    //   - カートページ: そもそもカートページに見積もり合計が表示されないので何もしない
  };
  // ===============================================================

  // ============ お知らせバー関連 ============

  function getBarTextElement() {
    return document.querySelector('.announcement-bar__text');
  }

  let originalBarText = null;

  function saveOriginalBarText() {
    const el = getBarTextElement();
    if (el && originalBarText === null) {
      originalBarText = el.innerHTML;
    }
  }

  function updateAnnouncementBar(total, itemCount) {
    const el = getBarTextElement();
    if (!el) return;

    if (itemCount === 0 || total === 0) {
      if (originalBarText !== null) {
        el.innerHTML = originalBarText;
      }
      return;
    }

    if (total >= CONFIG.threshold) {
      el.textContent = CONFIG.messageAchieved;
    } else {
      const remaining = CONFIG.threshold - total;
      const formatted = remaining.toLocaleString('ja-JP');
      el.textContent = CONFIG.messageBelow.replace('{remaining}', formatted);
    }
  }

  // ============ カートページ関連 ============

  // カートページの送料情報用 div の id
  const CART_NOTICE_ID = 'custom-cart-shipping-notice';

  // カートページの送料情報 div を取得 or 作成
  function ensureCartNoticeElement() {
    let notice = document.getElementById(CART_NOTICE_ID);
    if (notice) return notice;

    // tax-note の直後に挿入
    const taxNote = document.querySelector('.cart-totals__tax-note');
    if (!taxNote) return null;

    notice = document.createElement('div');
    notice.id = CART_NOTICE_ID;
    notice.className = 'custom-cart-shipping-notice';
    taxNote.parentNode.insertBefore(notice, taxNote.nextSibling);
    return notice;
  }

  function updateCartNotice(total, itemCount) {
    const notice = ensureCartNoticeElement();
    if (!notice) return; // カートページ以外では何もしない

    if (itemCount === 0 || total === 0) {
      notice.style.display = 'none';
      return;
    }

    notice.style.display = '';

    if (total >= CONFIG.threshold) {
      notice.textContent = CONFIG.messageAchieved;
      notice.classList.add('custom-cart-shipping-notice--achieved');
      notice.classList.remove('custom-cart-shipping-notice--below');
    } else {
      const remaining = CONFIG.threshold - total;
      const formatted = remaining.toLocaleString('ja-JP');
      notice.textContent = CONFIG.messageBelow.replace('{remaining}', formatted);
      notice.classList.add('custom-cart-shipping-notice--below');
      notice.classList.remove('custom-cart-shipping-notice--achieved');
    }
  }

  // ============ 共通: カート情報を取得して両方を更新 ============

  async function updateAll() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      // Shopify の cart.total_price は最小通貨単位(セント相当)で返るため100で割って円に変換
      // 例: 11,000円の商品 → cart.total_price は 1100000 → 11000円
      const total = (cart.total_price || 0) / 100;
      const itemCount = cart.item_count || 0;

      updateAnnouncementBar(total, itemCount);
      updateCartNotice(total, itemCount);
    } catch (err) {
      console.warn('[free-shipping-bar] cart fetch failed:', err);
    }
  }

  // 初期化
  function init() {
    saveOriginalBarText();
    updateAll();

    document.addEventListener('cart:update', updateAll);
    document.addEventListener('cart:refresh', updateAll);
    subscribeToCartPerformance();
  }

  function subscribeToCartPerformance() {
    if (window.Shopify && window.Shopify.PubSub && typeof window.Shopify.PubSub.subscribe === 'function') {
      try {
        window.Shopify.PubSub.subscribe('cart:updated', updateAll);
      } catch (e) { /* noop */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
